if (!customElements.get('mm-featured-collection')) {
  class MMFeaturedCollection extends HTMLElement {
    constructor() {
      super();
      this.isScrolling = '';
      this.spacing = parseFloat(this.getAttribute('data-spacing'));
      this.items = this.querySelectorAll('.mm-product-card');
      if (this.items.length == 0) return;

      this.resize();

      this.carousel = this.querySelector('.featured-collection__products');
      this.carousel.addEventListener('scroll', this.onScroll.bind(this));

      this.nextButton = this.querySelector('.featured-carousel__next');
      this.prevButton = this.querySelector('.featured-carousel__prev');
      this.nextButton.addEventListener('click', this.scrollCarousel.bind(this));
      this.prevButton.addEventListener('click', this.scrollCarousel.bind(this));
      this.dragging = false;

      this.rangeSlider = this.querySelector('.range-slider');
      this.rangeSlider.addEventListener('input', this.scrollDrag.bind(this));
      this.rangeSlider.addEventListener('mouseup', this.scrollDragStop.bind(this));

      this.onScroll();
      this.onScrollFinished();

      window.addEventListener('resize', this.resize.bind(this));
    }

    resize() {
      if (this.items.length > 0) {
        this.itemWidth = this.items[0].offsetWidth;
      }
    }

    scrollDrag() {
      const total = this.carousel.scrollWidth - this.carousel.offsetWidth;
      const percentage = total * (event.target.value / 100);
      this.carousel.scrollLeft = percentage;
      this.dragging = true;
    }

    scrollDragStop() {
      this.dragging = false;
    }

    getScrollPercent() {
      return Math.round(100 * this.carousel.scrollLeft / (this.carousel.scrollWidth - this.carousel.clientWidth));
    }

    scrollCarousel() {
      if (event.target.classList.contains('featured-carousel__next')) {
        this.carousel.scrollLeft += (this.itemWidth + this.spacing);
      } else {
        this.carousel.scrollLeft -= (this.itemWidth + this.spacing);
      }
    }

    onScroll() {
      if (!this.dragging) {
        this.rangeSlider.value = this.getScrollPercent();
      }
      clearTimeout(this.isScrolling);
      const _this = this;
      this.isScrolling = setTimeout(function () {
        _this.onScrollFinished(_this);
      }, 100);
    }

    onScrollFinished() {
      this.prevButton.disabled = this.carousel.scrollLeft <= 0;
      this.nextButton.disabled = this.carousel.offsetWidth + this.carousel.scrollLeft >= this.carousel.scrollWidth;
      this.rangeSlider.disabled = this.carousel.scrollWidth <= this.carousel.offsetWidth;
    }

  }

  customElements.define('mm-featured-collection', MMFeaturedCollection);
}
